import { render } from "./ItemKeywordSearch.vue?vue&type=template&id=0c1ee67b&scoped=true&ts=true"
import script from "./ItemKeywordSearch.vue?vue&type=script&lang=ts"
export * from "./ItemKeywordSearch.vue?vue&type=script&lang=ts"

import "./ItemKeywordSearch.vue?vue&type=style&index=0&id=0c1ee67b&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1361425700/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c1ee67b"]])

export default __exports__